import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Observer } from 'rxjs/Observer';
import Cookies from 'js-cookie';
import { environment } from 'environments/environment';
import * as $ from 'jquery';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { timeout, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { interval } from 'rxjs/observable/interval';

@Injectable()
export class OlapService {
  private headerState_loggedIn = new Subject<any>();
  private loanreview_currentId = new Subject<any>();
  private promoreview_currentId = new Subject<any>();
  loanStatus = new Subject<Object[]>();
  ajaxStatusObserver: Observer<any>;

  private other_settings = 'assets/other_settings.json';

  constructor(private http: HttpClient) {
  }

  setHeaderState(state: any) {
    console.log('set header invoked')
    this.headerState_loggedIn.next(state);
  }

  setLoanReviewId(id: any) {
    console.log('set review id: ' + id);
    this.loanreview_currentId.next(id);
  }

  setPromoReviewId(id: any) {
      console.log('set review id: ' + id);
      this.promoreview_currentId.next(id);
  }

  getHeaderState(): Observable<any> {
    return this.headerState_loggedIn.asObservable();
  }

  getLoanReviewId(): Observable<any> {
    return this.loanreview_currentId.asObservable();
  }

  getPromoReviewId(): Observable<any> {
      return this.promoreview_currentId.asObservable();
  }

  ajaxStatusObservable(): Observable<any> {
      return Observable.create((obs: Observer<any>) => {
          this.ajaxStatusObserver = obs;
      });
  }

  clearSession() {
      document.cookie = 'reviewId= ; expires = Thu, 01 Jan 1970 00:00:00 UTC; path=/';
      document.cookie = 'isStaff= ; expires = Thu, 01 Jan 1970 00:00:00 UTC; path=/';
      document.cookie = 'OLAP_UserGroup= ; expires = Thu, 01 Jan 1970 00:00:00 UTC; path=/';
      document.cookie = 'csrftoken= ; expires = Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  }

  rewriteAsJpgAndSubmit(file: any): Observable<any> {
      try {
          return Observable.create((obs: Observer<any>) => {
              const reader = new FileReader();
              reader.onload = function(event: any) {
                  const newImg = new Image();
                  newImg.src = '';
                  newImg.onload = function(e) {
                      const canvas = document.createElement('canvas');
                      canvas.width = newImg.width;
                      canvas.height = newImg.height;
                      const ctx = canvas.getContext('2d');
                      ctx.drawImage(newImg, 0, 0);
                      const fileContent = canvas.toDataURL('image/jpeg', 0.5);
                      // console.log('rewriteAsJpgAndSubmit:fileContent => ', fileContent);
                      obs.next(fileContent);
                  }
                  newImg.src = event.target.result;
              }
              if (file) {
                  reader.readAsDataURL(file);
              } else {
                  throw 'file object parameter is undefined.';
              }
          });
      } catch (err) {
          throw 'rewriteAsJpgAndSubmit:Exception => ' + err;
      }
  }


pdfToBase64(file: any): Observable<any> {
    try {
        return Observable.create((obs: Observer<any>) => {
            const reader = new FileReader();

            reader.onload = function(event: any) {
               const encodedFile = event.target.result;
               obs.next(encodedFile);
            }

            if (file) {
                reader.readAsDataURL(file);
            } else {
                throw 'file object parameter is undefined.';
            }
        });
    } catch (err) {
        throw 'pdfToBase64:Exception => ' + err;
    }
}

openPdfWindow(encoded_str=""): object {
    try{
        let byteCharacters = atob(encoded_str);
        let byteNumbers = new Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i++) 
        {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: 'application/pdf;base64' });
        const fileURL = URL.createObjectURL(file);

        return window.open(fileURL, "_blank", "titlebar=yes, resizable=yes");
    } catch (err) {
        return window.open(encoded_str, "_blank", "titlebar=yes, resizable=yes");
    }
}

    checkConnectionStatus(): Observable<any> {
        return this.http.get(environment.apiUrl + 'ping/')
                        .pipe(
                            timeout(3000),
                            catchError(e => {
                                alert('Slow internet connection...Please reconnect to your Wifi or Mobile data and try to resubmit.');
                                return of(0);
                            })
                        );
    }

    checkConnectionStatusWithDelay(): Observable<any> {
        let self = this;

        return interval(3000)
                .pipe(map((val) => {
                            return self.http.get<any>(environment.apiUrl + 'ping/')
                                .pipe(
                                    map((val) => { return val }),
                                    timeout(3000),
                                    catchError(e => {
                                        alert('SLOW OR NO INTERNET CONNECTION. Check your internet settings and try again.');
                                        return of(0);
                                    })
                                );
                        })
                    );
    }

    formatter(val: any, type: string): string {
        if (type === 'currency') {
            return val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        }
        if (type === 'dash4') {
            return val.toString().replace(/(\d+?)(?=(\d{4})+(?!\d)$)/g, '$1-')
        }
        return '';
    }

    loadJSON(json_url: string = ""): Observable<Object> {
        let json_url_ = json_url.trim().length ? json_url : this.other_settings;
        return this.http.get(json_url_);
    }
}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/service/olap-service.service.ts